import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  margin-bottom: 50px;
`;

export const List = styled.ul`
  padding: 0;
  height: 280px;
  overflow-y: auto;
`;

export const LoaderContainer = styled.li`
  list-style: none;
`;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/style.js